import sortBy from "lodash.sortby";

export default class GameLineup {
    constructor () {
        this.homeTeam = null;
        this.visitingTeam = null;
        this.players = {};
    }

    static load (lineup) {

        let newLineup = new GameLineup();

        newLineup.homeTeam = {
            name: lineup.home_team.name,
            id: lineup.home_team.id
        };
        newLineup.visitingTeam = {
            name: lineup.visiting_team.name,
            id: lineup.visiting_team.id
        };

        const mapPlayer = (player) => ({
            id: player.id,
            name: player.name,
            shirtNumber: player.shirt_number,
            position: player.position,
        });

        newLineup.players[newLineup.homeTeam.name] = sortBy(
            lineup.home_team.players.map(mapPlayer),
            "shirtNumber"
        );
        newLineup.players[newLineup.visitingTeam.name] = sortBy(
            lineup.visiting_team.players.map(mapPlayer),
            "shirtNumber"
        );

        return newLineup;
    }

    forEach (cb) {
        this.players[this.homeTeam.name].forEach(cb);
        this.players[this.visitingTeam.name].forEach(cb);
    }

    getPlayer (id, team) {
        let players;
        if (team !== undefined && team in this.players) {
            players = this.players[team];
        } else {
            players = this.players[this.homeTeam.name].concat(this.players[this.visitingTeam.name]);
        }
        return players.filter(p => p.id === id)[0];
    }

    teamsToText () {
        return [{
            id: this.homeTeam.id,
            value: this.homeTeam.name,
            text: this.homeTeam.name,
        },{
            id: this.visitingTeam.id,
            value: this.visitingTeam.name,
            text: this.visitingTeam.name,
        }];
    }

    getOppositeTeam (team) {
        if (team === undefined || !(team in this.players)) return undefined;
        if (team === this.homeTeam.name) return this.visitingTeam.name;
        return this.homeTeam.name;
    }

    playersToText (team, doDisplayNames) {

        let players;
        if (team !== undefined && team in this.players) {
            players = this.players[team];
        } else {
            players = this.players[this.homeTeam.name].concat(this.players[this.visitingTeam.name]);
        }

        if (doDisplayNames) {
            return players.map((player) => ({
                id: player.id,
                value: player.name,
                text: "" + player.shirtNumber + ": " + player.name,
                extraInfo: player.position ? player.position : "",
            }));
        }
        return players.map((player) => ({
            id: player.id,
            value: player.name,
            text: "" + player.shirtNumber,
            extraInfo: player.position ? player.position : "",
        }));
    }

    getKeeper(team) {
        if (team === undefined || !(team in this.players)) {
            return null;
        }
        const players = this.players[team];
        for (let i=0; i<players.length; ++i) {
            if (players[i].position === 'GK') {
                return players[i];
            }
        }

        return null;
    }
}



// WEBPACK FOOTER //
// ./src/js/include/GameLineup.js